import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { UnauthorizedPage } from "@/errors/pages/unauthorized-page";

export const Route = createFileRoute("/unauthorized")({
  component: () => (
    <>
      <DocumentTitle
        title="Unauthorized"
        description="You don't have permission to access this page."
      />
      <UnauthorizedPage />
    </>
  )
});
